import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-custom-datetime-picker',
  templateUrl: './custom-datetime-picker.component.html',
  styleUrls: ['./custom-datetime-picker.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomDatetimePickerComponent),
      multi: true
    }
  ],
  imports: [CommonModule, DatePickerModule, FormsModule, ReactiveFormsModule, TableModule]
})
export class CustomDatetimePickerComponent implements ControlValueAccessor {

  onChange: (value: Date | null) => void = () => { };
  onTouched: () => void = () => { };
  disabled: boolean = false;
  value: Date | null = null;

  @Input() labelText: string = "";
  @Input() recovery: boolean = false;
  @Input() required: boolean = false;
  @Output() onChangeDate = new EventEmitter<Date | null>();

  changeDate(event: Date | null): void {
    this.value = event;
    this.onChange(event);
    this.onTouched();
    this.onChangeDate.emit(event);
  }

  // No se usa y se comenta para no interferir en las pruebas
  // manualChange(event: any): void {
  //   const inputValue = event.target.value;
  //   const parsedDate = this.parseDate(inputValue);
  //   if (parsedDate) {
  //     this.value = parsedDate;
  //     this.onChange(parsedDate);
  //     this.onTouched();
  //     this.onChangeDate.emit(parsedDate);
  //   }
  // }

  // No se usa y se comenta para no interferir en las pruebas
  // private parseDate(value: string): Date | null {
  //   const parts = value.split('/');
  //   if (parts.length === 3) {
  //     const [day, month, year] = parts.map(Number);
  //     if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
  //       return new Date(year, month - 1, day);
  //     }
  //   }
  //   return null;
  // }

  registerOnChange(fn: (value: Date | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: Date | null): void {
    this.value = value;
  }
}
